import z from "zod";

export const Regions = [
    "topBar",
    "leftBar",
    "leftDrawer", 
    "rightBar",
    "rightDrawer", 
    "bottomBar", 
    "bottomDrawer", 
    "main",
    "modal"
] as const;
export type Region = typeof Regions[number];

export const RegionPropsSchema = z.object({
  backgroundColor: z.string().optional()
});

export type RegionProps = z.infer<typeof RegionPropsSchema>;